import { AsyncState } from 'react-use/lib/useAsyncFn';
import { useAsync } from 'react-use';

import { AppointmentFilter, AppointmentFilterQuery } from '@dreryk/egabinet-appointment-frontend-api';

import { Slot } from '@dreryk/watermelon';
import { performCqrsQueryGet } from '@dreryk/command-query-react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

type AppointmentsFiltersMeta = AsyncState<{
   patient?: string;
}>;

export const useAppointmentsFiltersMeta = (): AppointmentsFiltersMeta => {
   const { patientId } = visitPaths.useAppointmentsListSearchParams();

   return useAsync(async () => {
      const result = await performCqrsQueryGet<AppointmentFilter>(() => {
         const query = new AppointmentFilterQuery();
         query.patientId = Slot.emptyIfNull(String(patientId));
         return query;
      });

      return {
         ...(result.patientFirstName &&
            result.patientLastName && { patient: `${result.patientLastName} ${result.patientFirstName}` }),
      };
   }, [patientId]);
};
